import React, {PropTypes} from "react";
import {connect} from "react-redux";
import Button from "react-bootstrap/lib/Button";
import LinearProgress from "material-ui/LinearProgress";
import ReportSearch from "./ReportSearch";
import Dialog from "material-ui/Dialog";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import EmployeeTable from "./EmployeeTable";
import TeamInfoSummary from "./TeamInfoSummary";
import * as actions from "../../../redux/actions/Attendance/attendanceActions";
import csvConvert from '../../../classes/csvConvert';
import axios from "axios";
import LoadingSpinner from "../../loadingSpinner";

let startDate = new Date(new Date().getFullYear(), 0, 1);
let endDate = new Date();


class MyTeamRegularisationReport extends React.Component {

  constructor() {
    super();
    this.state = {
      indirect: 0,
      vertical: 0,
      pageNo: 0,
      attPageNo: 0,
      empId: "0",
      limitValue : 500,
      isVertical: false,
      loading:true,
      regularizationReports : []
    };
    this.changePageNo = this.changePageNo.bind(this);
    this.changeAttPage = this.changeAttPage.bind(this);
    this.formSubmit = this.formSubmit.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.changeEmp = this.changeEmp.bind(this);
    this.changeDirect = this.changeDirect.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.changeView = this.changeView.bind(this);
    this.revertSortFunc = this.revertSortFunc.bind(this);
    this.revertSortManagerIdFunc = this.revertSortManagerIdFunc.bind(this);
    this.revertSortRegApplyCountFunc = this.revertSortRegApplyCountFunc.bind(this);
    this.revertSortEmpIdFunc = this.revertSortEmpIdFunc.bind(this);
  }

  changePageNo(increase, decrease) {
    if (increase)
      this.setState({pageNo: this.state.pageNo + 1});
    else if (decrease)
      this.setState({pageNo: this.state.pageNo - 1});
  }

  changeAttPage(pageNo) {
      let request = new Object();
      request.startDate = this.state.startDate;
      request.endDate = this.state.endDate;
      request.empId = this.state.empId;
      this.setState({attPageNo: pageNo});
      this.formSubmit(request);
  }

  changeDirect() {
    if (this.state.indirect == 0)
      this.setState({indirect: 1, vertical: 0, empId : 0});
    else this.setState({indirect: 0})
  }

  changeView() {
    if(this.state.vertical == 0)
      this.setState({vertical: 1, indirect: 0, empId : 0});
    else this.setState({vertical: 0})
  }


  onSelect(event, index, value) {
    this.setState({showAll: value});
  }

  formSubmit(request, refresh) {
    this.setState({loading: true});
    let apiUrl = process.env.REQ_URL +'/attendance/team/getRegularizationReport';
    axios.post(apiUrl, { data: {
      empId : this.state.empId, indirect : this.state.indirect, vertical : this.state.vertical, startDate : request.startDate, endDate : request.endDate, limitValue : this.state.limitValue, offsetValue : this.state.pageNo
    }}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      console.log(response);
      this.setState({ regularizationReports : response.data.data, loading: false});
    }).catch((err)=> {
        console.log("Regularization Report Error");
    });
  }

  changeEmp(id) {
    this.setState({empId: id});
    if(id !=0){
       this.setState({vertical: 0, indirect: 0});
    }
  }

  revertSortFunc(a, b, order) {   // order is desc or asc
    if (order === 'desc') {
      return a.regApprovedCount - b.regApprovedCount;
    } else {
      return b.regApprovedCount - a.regApprovedCount;
    }
  }

  revertSortManagerIdFunc(a, b, order) {   // order is desc or asc
    if (order === 'desc') {
      return a.immReporting - b.immReporting;
    } else {
      return b.immReporting - a.immReporting;
    }
  }

  revertSortRegApplyCountFunc(a, b, order) {   // order is desc or asc
    if (order === 'desc') {
      return a.regApplyCount - b.regApplyCount;
    } else {
      return b.regApplyCount - a.regApplyCount;
    }
  }

  revertSortEmpIdFunc(a, b, order) {   // order is desc or asc
    if (order === 'desc') {
      return a.empId - b.empId;
    } else {
      return b.empId - a.empId;
    }
  }


  componentDidMount() {
      this.setState({isVertical: this.props.isVertical});
      let apiUrl = process.env.REQ_URL +'/attendance/team/getRegularizationReport';
      axios.post(apiUrl, { data: {
        empId : this.state.empId, indirect : this.state.indirect, vertical : this.state.vertical, startDate : startDate, endDate : endDate, limitValue : this.state.limitValue, offsetValue : this.state.pageNo
      }}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
        console.log(response);
        this.setState({ regularizationReports : response.data.data, loading: false});
      }).catch((err)=> {
          console.log("Regularization Report Error");
      });
  }

  handleClose() {
    this.setState({show: false})
  }

  render() {
    const options = {
      sortName: 'regApprovedCount',
      sortOrder: 'asc',
    }

    const action = [
      <Button disabled={this.state.attPageNo > 0 ? false : true}
              style={{marginRight: '50'}}
              onClick={()=> {
                this.changeAttPage(this.state.attPageNo - 1);
                this.setState({attPageNo: this.state.attPageNo - 1});
              }}
      >Previous</Button>,

      <Button disabled={this.props.details.length >= 25 ? false : true}
              style={{marginRight: '35%'}}
              onClick={()=> {
                this.changeAttPage(this.state.attPageNo + 1);
                this.setState({attPageNo: this.state.attPageNo + 1});
              }}
      >Next</Button>,
      <Button
        backgroundColor={'#428BCA'}
        onTouchTap={()=> {
          this.setState({show: !this.state.show})
        }
        }
      >Go Back</Button>

    ];
    const stylePaperInfo = {
      height: "100%",
      width: "100%",
      marginRight: '0%',
      marginLeft: '0',
      marginTop: '0%',
      textAlign: 'left',
      display: 'inline-block',
      borderBottomStyle: 'solid',
      borderWidth: '1px',
      borderColor: '#008bcf'
    };
    const stylePaperInfoTable = {
      height: "100%",
      width: "100%",
      borderBottomStyle: 'solid',
      borderWidth: '1px',
      borderColor: '#008bcf',
      marginRight: '5%',
      marginLeft: '0',
      marginTop: '0%',
      textAlign: 'left',
      display: 'inline-block',
    };


    let length = this.state.regularizationReports.length;

    return (
      <div>
        <div>
          <div role="tabpanel" className="tab-pane" id="apply">
            <div className="row clearfix">
              <div className="col-md-12" style={{paddingLeft: '0'}}>
                <div style={stylePaperInfo}>
                  <ReportSearch
                    changeDirect={this.changeDirect}
                    changeView={this.changeView}
                    indirect={this.state.indirect}
                    vertical={this.state.vertical}
                    isVertical={this.state.isVertical}
                    formSubmit={this.formSubmit}
                    empId={this.state.empId}
                    changeEmp={this.changeEmp}
                   />
                </div>
                <a href={this.state.csv} download={"teamAttendance.csv"}
                   ref={(input) => {
                     this.download = input;
                   }}/>

                {this.state.loading ? <LoadingSpinner/>:
                <div style={stylePaperInfoTable}>
                  <BootstrapTable data={this.state.regularizationReports} options={ options }
                    trClassName="rowX"
                    height="350"
                    tableStyle={{paddingTop: 0, margin: 0}}
                    striped={false} hover={true}
                    condensed={true}>
                    <TableHeaderColumn columnClassName="rowX"
                      filter={ {type: 'TextFilter', delay: 0, placeholder: 'Employee Id'} }
                      dataSort sortFunc={ this.revertSortEmpIdFunc } isKey={true} width={100} dataField="empId">Emp Id</TableHeaderColumn>
                    <TableHeaderColumn columnClassName="rowX"
                      filter={ {type: 'TextFilter', delay: 0, placeholder: 'Employee Name'} }
                      dataSort={true} width={200}
                      dataField="empName" >Emp Name</TableHeaderColumn>
                    <TableHeaderColumn columnClassName="rowX"
                      filter={ {type: 'TextFilter', delay: 0, placeholder: 'Manager Id'} }
                      dataSort sortFunc={ this.revertSortManagerIdFunc } width={100}
                      dataField="immReporting">Manager Id</TableHeaderColumn>
                    <TableHeaderColumn columnClassName="rowX"
                      filter={ {type: 'TextFilter', delay: 0, placeholder: 'Manager Name'} }
                      dataSort={true} width={200}
                      dataField="managerName">Manager Name</TableHeaderColumn>
                    <TableHeaderColumn columnClassName="rowX"
                      dataSort sortFunc={ this.revertSortRegApplyCountFunc } width={100}
                      dataField="regApplyCount">Regularization<br/>Apply Count</TableHeaderColumn>
                    <TableHeaderColumn columnClassName="rowX"
                      dataSort sortFunc={ this.revertSortFunc } width={100}
                      dataField="regApprovedCount">Regularized<br/>Count</TableHeaderColumn>
                    <TableHeaderColumn columnClassName="rowX"
                      dataSort={true} width={100}
                      dataField="noOfWeek">No. Of Weeks</TableHeaderColumn>
                  </BootstrapTable>
                </div>
                }
                <div className = "hidden" style={{padding: '0px'}}>
                  <div className="col-md-4" style={{marginLeft: '10%'}}></div>
                  <Button
                    disabled={this.props.teamPageNo > 0 ? false : true}
                    style={{marginRight: '10px'}}
                    onClick={()=> {

                      let request = new Object();
                      request.startDate = this.props.teamDates.startDate;
                      request.endDate = this.props.teamDates.endDate;
                      request.pageNo = this.props.teamPageNo - 1;
                      request.indirect = this.state.indirect;
                      request.vertical = this.state.vertical;
                      this.props.changeTeamPage(this.props.teamPageNo - 1, request);
                      this.props.dispatch(actions.getTeamAttendance(request));
                    }
                    }
                  >
                    Previous</Button>
                  <Button
                    style={{align: 'right', marginLeft: '10px'}}
                    disabled={length < 25 ? true : ((this.state.showAll == 0) ? false : true) }
                    onClick={()=> {
                      let request = new Object();
                      request.startDate = this.props.teamDates.startDate;
                      request.endDate = this.props.teamDates.endDate;
                      request.pageNo = this.props.teamPageNo + 1;
                      request.indirect = this.state.indirect;
                      request.vertical = this.state.vertical;
                      this.props.changeTeamPage(this.props.teamPageNo + 1, request);
                      this.props.dispatch(actions.getTeamAttendance(request));
                    }
                    }>
                    Next</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MyTeamRegularisationReport.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    state: state.attendance,
    employee: state.emp,
    regState: state.attendance[3],
    details: state.attendance[4],
    loading: state.ajaxCallsInProgress
  };

}


export default connect(mapStateToProps)(MyTeamRegularisationReport);




/** WEBPACK FOOTER **
 ** ./src/feature/attendance/TeamAttendance/MyTeamRegularisationReport.js
 **/